import { render, staticRenderFns } from "./KgjtWebsiteProductColor.vue?vue&type=template&id=096a4366&scoped=true&"
import script from "./KgjtWebsiteProductColor.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteProductColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096a4366",
  null
  
)

export default component.exports